import { MarkerType } from '../../core';
import type { MarkerDefinition } from '../../core';
import { sameMarkers, selectMarkerDefinitions, useMindmapStore } from '../../store';

/** The arrowhead outline in a 10 × 10 box, tip at (10, 5). */
const ARROW_POINTS = '1,1 10,5 1,9';
const MARKER_BOX = '0 0 11 10';
const TIP_X = 10;
const TIP_Y = 5;

const Arrowhead = ({ id, type, color, width, height, strokeWidth }: MarkerDefinition) => {
  const isClosed = type === MarkerType.ArrowClosed;
  return (
    <marker
      id={id}
      viewBox={MARKER_BOX}
      refX={TIP_X}
      refY={TIP_Y}
      markerWidth={width}
      markerHeight={height}
      markerUnits="strokeWidth"
      orient="auto-start-reverse"
    >
      <polyline
        points={isClosed ? `${ARROW_POINTS} 1,1` : ARROW_POINTS}
        fill={isClosed ? color : 'none'}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </marker>
  );
};

/** One `<marker>` per distinct arrowhead the edges use; edges point at them with `url(#id)`. */
export const MarkerDefinitions = () => {
  const definitions = useMindmapStore(selectMarkerDefinitions, sameMarkers);
  if (definitions.length === 0) return null;
  return (
    <defs>
      {definitions.map((definition) => (
        <Arrowhead key={definition.id} {...definition} />
      ))}
    </defs>
  );
};
